export default {
  "cat.shoes": "Buty",
  "cat.hoodies": "Bluzy/Swetry",
  "cat.tshirts": "Koszulki",
  "cat.jackets": "Kurtki",
  "cat.pants": "Spodnie/Szorty",
  "cat.headwear": "Nakrycia głowy",
  "cat.sets": "Zestawy",
  "cat.underwear": "Bielizna/Majtki",
  "cat.jersey": "Koszulki sportowe",
  "cat.accessories": "Akcesoria",
  "cat.bags": "Torby",
  "cat.belts": "Paski",
  "cat.perfumes": "Perfumy",
  "cat.other": "Inne rzeczy",
};